module.exports = __webpack_public_path__ + "static/KC11-59eb44cfec52aeb385bdee108cc9df40.png";